import React from "react";
import { Typography, useMediaQuery, useTheme, Stack, Box } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import './index.css'; 

function ContactCard() {
  const cardData = [
    {
      icon: <EmailIcon className="icon-color" />,
      titleText: "Email Support",
      subTitleText: "Our Team responds in real time",
      infoText: "info@aspiretaxbook.com.au"
    },
    {
      icon: <LocationOnIcon className="icon-color" />,
      titleText: "Our Office",
      subTitleText: "Our location in real life",
      infoText: "12 Klandy Drive Kalkallo, VIC, 3064, Australia."
    },
    {
      icon: <PhoneIcon className="icon-color" />,
      titleText: "Call Us Directly",
      subTitleText: "Available during working hours",
      infoText: "+61 449 609 681"
    },
  ];

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Stack
      direction={{ xs: "column", sm: "row", md: "row", lg: "row" }}
      spacing={{ sm: 3 }}
      justifyContent={isMobile ? "center" : "space-between"}
      alignItems={"start"}
      className="contact-stack"
    >
      {cardData.map((card, index) => (
        <Box 
          key={index} 
          className={`contact-card${isMobile ? ' mobile' : ''}`}
          sx={isMobile ? { my: 1, mx: 0, width: '100%' } : {}}
        >
          <Stack spacing={2} alignItems={isMobile ? "center" : "flex-start"}>
            <Box className={`icon-wrapper ${isMobile ? "center-align" : ""}`}>
              {card.icon}
            </Box>
            <Box className={`text-box ${isMobile ? "center-text" : ""}`}>
              <Typography className={`title-text ${isMobile ? "center-text" : ""}`}>
                {card.titleText}
              </Typography>
              <Typography className={`subtitle-text ${isMobile ? "center-text" : ""}`}>
                {card.subTitleText}
              </Typography>
            </Box>
            <Typography className={`info-text ${isMobile ? "center-text" : ""}`}>
              {card.infoText}
            </Typography>
          </Stack>
        </Box>
      ))}
    </Stack>
  );
}

export default ContactCard;
